<br/>
<div style="text-align: center;">

    <h1>Solicitar Préstamo</h1>
</div>
<br/>

<form #prestamoForm=ngForm>

    <div class="container principal" id="tabla" style="background-color: white; padding-top: 10px; padding-bottom:50px">

        <div class="container principal">
           <p>Según lo indicado por la SUSESO, <b>los afiliados deben conservar los originales de los documentos de respaldo de los </b>
           <br/>
           <b>beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5 años</b> (Circular N°3623 de fecha 18.10.2021)
           <br/>
           <br/>
           La adulteración de datos y/o documentos contables constituye una falta grave a la probidad lo cual 
           conlleva expulsión total del Servicio de Bienestar y el inicio inmediato de una investigación o sumario  administrativo.   
           </p>  
            <p><b>Manual de prestamo: </b> <a href="{{this.linkTexto}}" target="_blank">
                Prestamo</a>.</p>     
            <br/>
            <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

                <div class="row">

                    <div class="col-lg-4"> Afiliado:</div>

                    <div class="col-lg-8">
                        <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                        </h2>

                    </div>

                </div>

            </div>
            <div *ngIf="rol != 'ROLE_AFILIADO'">

                <div class="row line">

                    <div class="col-lg-2"> </div>

                    <div class="col-lg-2">
                        <h2> Rut Afiliado </h2>
                    </div>

                    <div class="col-lg-4">

                        <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado" #rutAfiliado="ngModel" class="form-control" type="text" required placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>

                    <div class="col-lg-4">

                        <button class="btn btn-primary" id="btnvalida" (click)="buscaCodeudor(buscador.rutAfiliado,3)" [disabled]="rutAfiliado.invalid">
    
                        Buscar
    
                    </button>

                    </div>
                </div>
                <div class="row line">

                    <div class="col-lg-4"> </div>
                    <div class="col-lg-5">
                        <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                        </h2>
                    </div>
                </div>
            </div>

        </div>
        <br/>
        <div class="row line">
            <div class="col-lg-3">
                <h2>Datos Préstamo</h2>
            </div>
        </div>
        <br>
        <div class="row line">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3">
                <p>Monto Solicitado </p>
            </div>

            <div class="col-lg-6">
                <input matInput type="number" id="montoSolicitado" value="{{this.prestamo.montoSolicitado}}" name="montoSolicitado" [(ngModel)]="prestamo.montoSolicitado" #montoSolicitado="ngModel" placeholder="Monto Máximo Disponible" required max="{{this.totalMaximo}}"
                    (ngModelChange)="actualizarTotalReal(prestamo.montoSolicitado)" [disabled]="prestamo.deshabilitado"/>
                <div *ngIf="prestamo.errors && prestamo.touched" class="alert alert-danger">

                    <div *ngIf="prestamo.errors.required"> Ingrese Monto a Solicitar. </div>

                </div>
            </div>
            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> </div>
            <br>
        </div>
        <br/>
        <div class="row line">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3">
                <p>Monto Real Solicitado</p>
            </div>

            <div class="col-lg-6">
                <input matInput type="number" id="totalReal" value="{{this.prestamo.totalReal}}" name="totalReal" [(ngModel)]="prestamo.totalReal" #totalReal="ngModel" disabled>

            </div>
            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> </div>
            <br>
        </div>
        <br/>
        <div class="row line">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3">
                <p>Cantidad de cuotas</p>
            </div>
            <div class="col-lg-2">
                <mat-select class="form-control" id="cantidadCuotas" name="cantidadCuotas" [disabled]="prestamo.deshabilitado" [(ngModel)]="prestamo.cantidadCuotas" #cantidadCuotas="ngModel" required (selectionChange)="actualizaInteres()">
                    <mat-option value="0">

                        SELECCIONE....

                    </mat-option>
                    <mat-option *ngFor="let cuota of this.cuotas" value="{{cuota.id}}">

                        {{cuota.descripcion}}

                    </mat-option>

                </mat-select>


            </div>

            <div *ngIf="prestamo.errors && prestamo.touched" class="alert alert-danger">

                <div *ngIf="prestamo.errors.required"> Seleccione Cantidad de Cuotas. </div>

            </div>
            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> </div>
            <br>
        </div>
        <br/>
        <div class="row line">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3">
                <p>Tasa Interés</p>
            </div>

            <div class="col-lg-6">
                <label>1.3%</label> &nbsp; &nbsp;
                <input matInput type="number" id="totalTasa" value="{{this.prestamo.totalTasa}}" name="totalTasa" disabled [(ngModel)]="prestamo.totalTasa" #totalTasa="ngModel">

            </div>
            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> </div>
            <br>
        </div>
        
        <br/>
        <div class="row line">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3">
                <p>Valor Capacidad de Descuento Mensual</p>
            </div>

            <div class="col-lg-6">
                <input matInput type="number" id="capacidadDescuento" value="{{this.prestamo.capacidadDescuento}}" name="capacidadDescuento" [(ngModel)]="prestamo.capacidadDescuento" #capacidadDescuento="ngModel" placeholder="Monto Máximo Disponible" disabled>

            </div>
            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> </div>
            <br>
        </div>
        <br/>
        
        <div class="row line">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3">
                <p>Tipo de Préstamo</p>
            </div>
            <div class="col-lg-3">

                <mat-select class="form-control" [disabled]="prestamo.deshabilitado" name="tipoPrestamo" #tipoPrestamo="ngModel" [(ngModel)]="prestamo.tipoPrestamo" required>

                    <mat-option value="0">
                        SELECCIONE....
                    </mat-option>
                    <mat-option *ngFor="let tipo of this.tipos" value="{{tipo.id}}">
                        {{tipo.descripcion}}
                    </mat-option>
                </mat-select>

            </div>
            <div *ngIf="prestamo.errors && prestamo.touched" class="alert alert-danger">

                <div *ngIf="prestamo.errors.required"> Seleccione Tipo Préstamo. </div>

            </div>
            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> </div>

        </div>
        <br/>


        <div class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="prestamo.archivoTest" (change)="seleccionaArchivo($event, 0)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"> </div>

        </div>
        <br/>
        <div *ngIf="cantidadArchivos > 1" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (2) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo2" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="prestamo.archivoTest2" (change)="seleccionaArchivo($event, 1)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>
        <br/>
        <div *ngIf="cantidadArchivos > 2" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (3) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo3" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="prestamo.archivoTest3" (change)="seleccionaArchivo($event, 2)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>
        <br/>
        <div *ngIf="cantidadArchivos > 3" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (4) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo4" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="prestamo.archivoTest4" (change)="seleccionaArchivo($event, 3)">

            </div>
            <div class="col-lg-1"> </div>
            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <br/>
        <div *ngIf="cantidadArchivos > 4" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (5) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo5" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="prestamo.archivoTest5" (change)="seleccionaArchivo($event, 4)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>

        <br/>
        <div *ngIf="cantidadArchivos > 5" class="row line">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <p> Adjuntar (6) </p>
            </div>

            <div class="col-lg-5">

                <input type="file" class="form-control-file" name="archivo6" required accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="prestamo.archivoTest6" (change)="seleccionaArchivo($event, 5)">

            </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

        </div>
        <br/>
        <div class="row line">

            <div class="col-lg-2 col-sm-2"> </div>

            <div class="col-lg-6 col-sm-1"></div>

            <div class="col-lg-3 col-sm-1">
                <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">
                    <button class="btn btn-primary" (click)="calcularPlanPago()"  style="margin-right: 10px;">
                Calcular
            </button>
            <button class="btn btn-danger" (click)="nuevoMontoCalcular()">
                renovar monto
            </button>  
                </div>
             
                <div >
                           
                </div>
                <div *ngIf="prestamo.errors && prestamo.touched" class="alert alert-danger">

                    <div *ngIf="prestamo.errors.required">Presione el botón para conocer el plan de pago </div>

                </div>
            </div>

            <div class="col-lg-1 col-sm-1"> </div>

        </div>
        <br/>


        <br/>
        <br/>

        <div class="row line">
            <div class="col-lg-4">
                <h1>Plan de Pago Préstamo</h1>
            </div>
        </div>
        <br>
        <div class="row line">
            <div class="col-lg-1 col-sm-1"> </div>
            <div class="col-lg-4">
                <b>Monto Préstamo CLP 
                    <label id="montoTotalCalculado" name="montoTotalCalculado" >{{this.montoTotalCalculado}}</label></b>
            </div>
        </div>
      
        <div class="table-responsive" *ngIf="this.mostrarPlan">

            <table class="table" id="tablaPlan" name="tablaPlan">

                <thead style="background-color: #0f69b4;color:white;">
                    <tr>
                        <th style="text-align: center;">Nro. cuota</th>
                        <th style="text-align: center;">Fecha de pago</th>
                        <th style="text-align: center;">Monto Cuota</th>
                        <th style="text-align: center;">% Interés</th>
                        <th style="text-align: center;">Monto Total Cuota</th>
                    </tr>
                </thead>
                <tbody>

                    <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let plan of planes | paginate: configPlan; let i = index">
                        <td style="text-align: center;">{{plan.numCuota}}</td>
                        <td style="text-align: center;">{{plan.fechaPago}}</td>
                        <td style="text-align: center;">{{plan.montoCuota}}</td>
                        <td style="text-align: center;">{{plan.tasaInteres}}</td>
                        <td style="text-align: center;">{{plan.montoTotalCuota}}</td>
                    </tr>
            </table>
        </div>


        <br>


        <br/><br/>

        <div class="row line">
            <div class="col-lg-3">
                <h1>Codeudores</h1>
            </div>
        </div>
        <br>
        <div class="row line">

            <div class="col-lg-2"> </div>
            <div class="col-lg-2">
                <p>RUT Codeudor 1: </p>
            </div>

            <div class="col-lg-4">

                <input name="rut" id="rutCodeudor1" class="form-control" type="text" #rut="ngModel" [(ngModel)]="buscador.rut" placeholder="Ingrese el RUT (11111111-1)" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />
            </div>
            <div *ngIf="prestamo.errors && prestamo.touched" class="alert alert-danger">

                <div *ngIf="prestamo.errors.required"> Indique y busque un rut para el primer codeudor </div>

            </div>
            <div class="col-lg-4">
                <button class="btn btn-primary" id="btnvalida" (click)="buscaCodeudor(buscador.rut,1)">

                        Buscar

                </button>

            </div>
        </div>
        <br/>
        <div class="row line">
            <div class="col-lg-3"> </div>
            <div class="col-lg-5">Nombre: <b>{{this.codeudor.nombreCodeudor}}</b> RUT:<b>{{this.codeudor.rutCodeudor}}</b>
                <input type="hidden" name="idCodeudor" value={{this.codeudor.idCodeudor}}></div>
            <br>
        </div>
        <br/>
        <div class="row line">

            <div class="col-lg-2"> </div>
            <div class="col-lg-2">
                <p>RUT Codeudor 2: </p>
            </div>

            <div class="col-lg-4">

                <input name="rut" id="rutCodeudor2" class="form-control" type="text" #rut2="ngModel" [(ngModel)]="buscador.rut2" placeholder="Ingrese el RUT (11111111-1)" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />
            </div>
            <div *ngIf="prestamo.errors && prestamo.touched" class="alert alert-danger">

                <div *ngIf="prestamo.errors.required"> Indique y busque un rut para el segundo codeudor </div>

            </div>
            <div class="col-lg-4">
                <button class="btn btn-primary" id="btnvalida2" (click)="buscaCodeudor(buscador.rut2,2)">

                        Buscar

                    </button>

            </div>
        </div>
        <br/>
        <div class="row line">
            <div class="col-lg-3"> </div>
            <div class="col-lg-5">Nombre: <b>{{this.codeudor2.nombreCodeudor}}</b> RUT:<b>{{this.codeudor2.rutCodeudor}}</b>
                <input type="hidden" name="idCodeudor2" value={{this.codeudor2.idCodeudor}}></div>

            <br>



            <br/>

            <br/>
            <div class="row line">

                <div class="col-lg-2 col-sm-2"> </div>

                <div class="col-lg-6 col-sm-1"></div>

                <div class="col-lg-3 col-sm-1">
                    <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'">
                        <button class="btn btn-secondary" (click)="limpiarCodeudores()">
                Limpiar Codeudores
            </button>
                    </div>
                </div>

                <div class="col-lg-1 col-sm-1 "> </div>
                <br/>
            </div>
            <br/>
        </div>
        <br/>

    </div>
    <div class="container principal ">
        <br/>
        <div class="row line ">

            <div class="col-lg-5 col-sm-2 "> </div>


         
          <div class="col-lg-3 col-sm-1 ">
                <div *ngIf="rol !='ROLE_EJECUTIVO_CAIP' && rol !='ROLE_CONTABILIDAD' && rol !='ROLE_ENCARGADO_CONTABILIDAD'">
                    <button class="btn btn-success " (click)="solicitar(prestamoForm)">

                Solicitar

                 </button>
                </div>
            </div>

            <div class="col-lg-1 col-sm-1 "> </div>
            <br/>
        </div>

    </div>
    <br/>
</form>
<br/><br/><br/>